import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.reduce";
import _get from "lodash/get";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import config from '@nerdwallet/app-config';
/**
 * Provides reflected object of feature flags, meant for use with default export
 * @type {Object}
 */

export var FEATURE_FLAGS = Object.keys(_get(config, 'FEATURE_FLAGS', {})).reduce(function (acc, k) {
  return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, k, k));
}, {});
/**
 * Get an app-config driven feature flag.
 * @example
 * // given config
 * FEATURE_FLAGS:
 *   FOO: true
 * @example
 * import getFeatureFlag, { FEATURE_FLAGS } from '@nerdwallet/home-app-lib/feature-flags';
 *
 * getFeatureFlag(FEATURE_FLAGS.FOO); // true
 * @see https://www.github.com/NerdWallet/nwjs-feature-flags
 * @deprecated
 * @function
 * @param  {String} key The key
 * @return {Mixed}    The value of the flag
 */

export default (function (key) {
  return _get(config, ['FEATURE_FLAGS', key]);
});